function backBtn () {
    // const backBtn = document.querySelector('.single-product__back');

    // if(backBtn) {
    //     backBtn.addEventListener('click', (e)=> {
    //         e.preventDefault();
    //         // Перенаправляем пользователя на предыдущую страницу
    //         window.history.back();
    //     });
    // }
}

export default backBtn;